import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Home, ArrowRight } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center relative overflow-hidden">
      {/* Decorative background elements */}
      <motion.div 
        className="absolute inset-0 overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="absolute w-[500px] h-[500px] bg-[#EA295A]/5 rounded-full blur-3xl -top-20 -right-20" />
        <div className="absolute w-[300px] h-[300px] bg-blue-500/5 rounded-full blur-2xl top-40 -right-10" />
        <div className="absolute w-[400px] h-[400px] bg-purple-500/5 rounded-full blur-2xl bottom-0 -right-20" />
      </motion.div>

      <div className="relative max-w-2xl mx-auto px-4 py-16 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-9xl font-bold text-[#EA295A] mb-8">404</h1>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Úps! Síðan fannst ekki
          </h2>
          <p className="text-xl text-gray-600 mb-12">
            Því miður fannst síðan sem þú ert að leita að ekki. Hún gæti hafa verið færð eða eytt.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="bg-[#EA295A] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#d01d4c] transition-all shadow-lg shadow-[#EA295A]/20 hover:shadow-xl hover:shadow-[#EA295A]/30 flex items-center justify-center w-full sm:w-auto"
              >
                <Home className="w-5 h-5 mr-2" />
                Aftur á forsíðu
              </motion.button>
            </Link>
            <Link to="/hafa-samband">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="bg-white text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all border border-gray-200 shadow-sm flex items-center justify-center w-full sm:w-auto"
              >
                Hafa samband
                <ArrowRight className="ml-2 w-5 h-5" />
              </motion.button>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;